import React from 'react';
import { BookingsTableData } from './helpers';
import { CellProps } from 'react-table';
import styles from './BookingsTable.module.css';
import { Button } from '@round/ui-kit';
import cn from 'classnames';
import { ReactComponent as LockIcon } from '../../../assets/Lock.svg';

type ApproveToBillCellProps<T extends BookingsTableData> = CellProps<T> & {
    approveToBill?: (booking: T) => void;
};

const ApproveToBillCell = <T extends BookingsTableData>({ approveToBill, value, row }: ApproveToBillCellProps<T>) => {
    const { reasons_to_block_approval_to_bill } = row.original;

    const approved = Boolean(value);
    const disabled = approved || !!reasons_to_block_approval_to_bill?.length;
    return (
        <Button
            className={cn(styles.approveToBill)}
            disabled={disabled}
            onClick={() => {
                if (typeof approveToBill === 'function') {
                    approveToBill(row.original);
                }
            }}
        >
            {approved ? (
                <>
                    <LockIcon className={styles.approveToBillIcon} /> Approved
                </>
            ) : (
                'Approve'
            )}
        </Button>
    );
};

export default ApproveToBillCell;
